export const ChatBubble = ({ text, isOwner, time }) => (
  <div className={`flex ${isOwner ? "justify-end" : "justify-start"}`} data-testid={`chat-bubble-${isOwner ? "owner" : "visitor"}`}>
    <div className="max-w-[78%]">
      <div
        className={
          isOwner
            ? "bg-brand-blue text-white rounded-2xl rounded-br-md px-4 py-2.5 shadow-sm"
            : "bg-slate-100 text-slate-800 rounded-2xl rounded-bl-md px-4 py-2.5"
        }
      >
        <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{text}</p>
      </div>
      {time && (
        <p className={`text-[11px] text-slate-400 mt-1 ${isOwner ? "text-right" : "text-left"}`}>{time}</p>
      )}
    </div>
  </div>
);
